import SocialMedia from "./SocialMedia";
import React from "react";

export default function TikTok() {  
    // lead_id is included here because it is mapped in Segment
    return <SocialMedia 
    cacheKey="tiktok_cache" 
    requiredParameters=
        {{'ttclid': true,
        'lead_id': false}}/>; 
}